import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminService } from '../../../../services/admin.service';
import { MessageService } from 'primeng/api';

// Import PrimeNG components
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-system-message-board',
    imports: [CommonModule, FormsModule, InputTextareaModule, ButtonModule, ToastModule],
    providers: [MessageService],
    templateUrl: './system-message-board.component.html',
    styleUrl: './system-message-board.component.scss'
})
export class SystemMessageBoardComponent implements OnInit {
  facility: string = '';
  messageBoard: string = '';
  lastUpdateDate: Date = new Date();
  showSuccessMessage: boolean = false;
  
  constructor(
    private adminService: AdminService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadSystemMessage();
  }

  loadSystemMessage(): void {
    // In a real implementation, this would call your AdminService
    this.adminService.getDailyUpdateSystemMessage().subscribe(response => {
      this.messageBoard = response.result;
      this.lastUpdateDate = new Date(response.lastUpdate);
    });
    
    // For now, using sample data
   // this.messageBoard = 'The TLR Application has been upgraded. Please let us know if you have any issues. Have a safe day.';
    this.lastUpdateDate = new Date();
  }
  updateSystemMessage(): void {
    this.facility = localStorage.getItem('current_facility_id') || '';
    // Create simplified request body with only facilityID and message
    const requestBody = {
      facilityID: this.facility,
      message: this.messageBoard
    };
    
    
    // Call the admin service method
    this.adminService.updateDailyUpdateSystemMessage(requestBody).subscribe({
      next: (response) => {
        
        // Update the last update date
        this.lastUpdateDate = new Date();
        
        // Show success message
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'System message updated successfully',
          life: 3000
        });
        
        // Hide success message flag (if used in template)
        this.showSuccessMessage = true;
        setTimeout(() => {
          this.showSuccessMessage = false;
        }, 3000);
      },
      error: (error) => {
        console.error('Error updating system message:', error);
        
        // Show error message
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update system message. Please try again.',
          life: 5000
        });
      }
    });
  }
}
